import type { Content } from 'pdfmake/interfaces';
import type { ViewBlock } from '@/data/schemas';
import { resolveTextStyle } from '../formatters';
import { BLOCK_SPACING } from '../layout';

type TextBlock = Extract<ViewBlock, { type: 'text' }>;

export function renderTextBlock(block: TextBlock): Content {
  return {
    text: block.content,
    style: resolveTextStyle(block.variant ?? 'normal'),
    margin: [0, 0, 0, BLOCK_SPACING],
  };
}
